/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_CalculatingInputs */

const en_delivery_calculating = /** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculating distance...`)
};

const es_delivery_calculating = /** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculando distancia...`)
};

const fr_delivery_calculating = /** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcul de la distance...`)
};

const de_delivery_calculating = /** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernung berechnen...`)
};

const id_delivery_calculating = /** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menghitung jarak...`)
};

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const ja_delivery_calculating = en_delivery_calculating;

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const zh_delivery_calculating = en_delivery_calculating;

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const ar_delivery_calculating = en_delivery_calculating;

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const it_delivery_calculating = en_delivery_calculating;

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const ru_delivery_calculating = en_delivery_calculating;

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const pt_delivery_calculating = en_delivery_calculating;

/** @type {(inputs: Delivery_CalculatingInputs) => LocalizedString} */
const ko_delivery_calculating = en_delivery_calculating;

/**
* | output |
* | --- |
* | "Calculating distance..." |
*
* @param {Delivery_CalculatingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_calculating = /** @type {((inputs?: Delivery_CalculatingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_CalculatingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_calculating(inputs)
	if (locale === "es") return es_delivery_calculating(inputs)
	if (locale === "fr") return fr_delivery_calculating(inputs)
	if (locale === "de") return de_delivery_calculating(inputs)
	if (locale === "ja") return ja_delivery_calculating(inputs)
	if (locale === "zh") return zh_delivery_calculating(inputs)
	if (locale === "ar") return ar_delivery_calculating(inputs)
	if (locale === "id") return id_delivery_calculating(inputs)
	if (locale === "it") return it_delivery_calculating(inputs)
	if (locale === "ru") return ru_delivery_calculating(inputs)
	if (locale === "pt") return pt_delivery_calculating(inputs)
	return ko_delivery_calculating(inputs)
});